module.exports = __webpack_public_path__ + "h5/img/master_4.5f15ce50.png";